<template>
    <div>
        <div ref="myChart" :style="{ width: width+'px', height:height+'px' }"></div>
    </div>
</template>

<script>
let echarts = require('echarts/lib/echarts')
// 引入折线图组件
require('echarts/lib/chart/line')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/component/grid')
require('echarts/lib/component/dataZoom')



export default {
    props:{
        width:{
            type:Number,
            default:375
        },
        height:{
            type:Number,
            default:292
        },
    },
    data() {
        return {
            option: {
                tooltip: {
                    trigger: 'axis',
                    position:'left'
                },
                title: {
                    text: 'PP/PE市场行情走势图',
                    textStyle: {
                        fontSize: 16
                    },
                    left: 'center',
                },
                grid: {
                    left: 55,
                    right:40   
                },
                legend: {
                    data: ['PP', 'PE'],
                    type: 'plain',
                    orient: 'vertical',
                    right: 10,
                    top: 15,
                    bottom: 5,
                    borderColor: '#FF8800'
                },
                xAxis: {
                    type: 'category',
                    name: '日期',
                    boundaryGap: false,
                    data: [],
                },
                yAxis: {
                    name: '元',
                    type: 'value',
                    boundaryGap: [0, '100%'],
                    min: '',
                    max: '',
                    // splitNumber:6  
                },
                dataZoom: [{
                    type: 'inside',
                    start: 20,
                    end: 100,
                },
                // {
                //     start: 0,
                //     end: 90,
                //     handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                //     handleSize: '80%',
                //     handleStyle: {
                //         color: '#fff',
                //         shadowBlur: 3,
                //         shadowColor: 'rgba(0, 0, 0, 0.6)',
                //         shadowOffsetX: 2,
                //         shadowOffsetY: 2,
                //     }
                // }
                ],
                series: [
                    {
                        name: 'PE',
                        type: 'line',
                        smooth: true,
                        symbol: 'none',
                        sampling: 'average',
                        itemStyle: {
                            color: '#1E90FF'
                        },
                        data: []
                    },
                    {
                        name: 'PP',
                        type: 'line',
                        smooth: true,
                        symbol: 'none',
                        sampling: 'average',
                        itemStyle: {
                            color: '#FF8800' //改变折线颜色
                        },
                        data: []
                    }

                ]
            }
        }
    },
    created() {
        this.getChartsData()
    },
    mounted() {
        this.drawLine()
    },
    methods: {
        async getChartsData() {
            let params = {
                url: 'http://MID-CLIENT-MALL/messageService/priceTrendService/queryMaterialTrend',
                body: {}
            }

            this.invoke(params).then(res => {

                if (res) {
                    let dateTime = [],
                        dataPe = [],
                        dataPp = [];
                    let valArr = res.map(item => {
                        if (item.materialCode === "PE") {
                            dataPe.push(item.materialPrice)
                            let replaces = item.statisticalDate.substr(5, 5);
                            // let replaces = item.statisticalDate.replace('-', '/').replace('-', '/');
                            dateTime.push(replaces);
                            this.option.xAxis.data = dateTime
                            this.option.series[0].data = dataPe
                        } else {
                            dataPp.push(item.materialPrice);
                            this.option.series[1].data = dataPp;

                        }
                        return item.materialPrice;
                    });
                        this.option.yAxis.max = Math.ceil(Math.max(...valArr));
                        this.option.yAxis.min = Math.ceil(Math.min(...valArr));
                    this.drawLine()
                }
            });
        },
        drawLine() {
            //初始化echarts实例
            let myChart = echarts.init(this.$refs['myChart'])
            // 绘制图表
            myChart.setOption(
                this.option
            );
        }
    }
}


</script>

<style lang="scss" scoped>
</style>